import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { SetupFarmaCallout, SetupFarmaFooter, SetupFarmaHeader, SetupPMCConfiguration } from './components';
import { useFarma } from './hooks/useFarma';
import { DEFAULT_SETUP_FARMA_VALUES, SetupFarmaFormValues, setupFarmaSchema, toSetupFarmaFormValues } from './schema';

export const SetupFarma = () => {
  const { configFarma, saveConfigFarma, isUpdating } = useFarma();

  // `values` reseta o form (e os defaults usados por reset/resetField) sempre que a config salva muda
  const savedValues = React.useMemo(() => (configFarma ? toSetupFarmaFormValues(configFarma) : undefined), [configFarma]);

  const formMethodsIpaFarma = useForm<SetupFarmaFormValues>({
    resolver: zodResolver(setupFarmaSchema),
    defaultValues: DEFAULT_SETUP_FARMA_VALUES,
    values: savedValues,
  });

  return (
    <FormProvider {...formMethodsIpaFarma}>
      <SetupFarmaHeader />
      <SetupPMCConfiguration isUpdating={isUpdating} />
      <SetupFarmaCallout />
      <SetupFarmaFooter onSave={saveConfigFarma} isUpdating={isUpdating} />
    </FormProvider>
  );
};
